export default __webpack_public_path__ + "static/backgroundFeatures-2db87c0b93f84c6fc77691714d95ef47.jpg";